import React, { useState } from 'react';
import axios from 'axios';

const API = 'https://cineshorts-ai-production.up.railway.app';

const LANGUAGES = [
  { code: 'en', flag: '🇺🇸', name: 'English' },
  { code: 'ur', flag: '🇵🇰', name: 'اردو' },
  { code: 'ar', flag: '🇸🇦', name: 'العربية' },
  { code: 'hi', flag: '🇮🇳', name: 'हिन्दी' },
  { code: 'bn', flag: '🇧🇩', name: 'বাংলা' },
  { code: 'es', flag: '🇪🇸', name: 'Español' },
  { code: 'fr', flag: '🇫🇷', name: 'Français' },
  { code: 'de', flag: '🇩🇪', name: 'Deutsch' },
  { code: 'zh', flag: '🇨🇳', name: '中文' },
  { code: 'ja', flag: '🇯🇵', name: '日本語' },
  { code: 'ko', flag: '🇰🇷', name: '한국어' },
  { code: 'tr', flag: '🇹🇷', name: 'Türkçe' },
  { code: 'ru', flag: '🇷🇺', name: 'Русский' },
  { code: 'pt', flag: '🇵🇹', name: 'Português' },
  { code: 'fa', flag: '🇮🇷', name: 'فارسی' },
];

const TRANSLATIONS = {
  en: {
    title: '💳 Payment',
    selectedPlan: 'Selected Plan',
    paymentMethod: 'Payment Method',
    howToPay: '📱 How to Pay',
    step1: 'Open app',
    step2: 'Go to Send Money',
    step3: 'Send to this number:',
    step4: 'Amount:',
    step5: 'Copy Transaction ID',
    step6: 'Paste below',
    step7: 'Upload payment screenshot',
    transactionId: 'Enter Transaction ID',
    transactionRequired: '* Required',
    transactionPlaceholder: 'e.g: TXN123456789',
    screenshotLabel: '📸 Upload Payment Screenshot',
    screenshotUploaded: '✅ Screenshot uploaded!',
    submitBtn: '✅ Submit Payment',
    submitting: '⏳ Submitting...',
    successTitle: 'Payment Submitted!',
    successMsg: 'Admin will activate your plan within 24 hours. Use Free plan until then.',
    goToDashboard: 'Go to Dashboard',
    errorTxn: 'Transaction ID is required!',
    errorScreenshot: 'Screenshot is required!',
    errorGeneral: 'An error occurred!',
  },
  ur: {
    title: '💳 ادائیگی',
    selectedPlan: 'منتخب پلان',
    paymentMethod: 'ادائیگی کا طریقہ',
    howToPay: '📱 ادائیگی کیسے کریں',
    step1: 'ایپ کھولیں',
    step2: 'Send Money پر جائیں',
    step3: 'اس نمبر پر بھیجیں:',
    step4: 'رقم:',
    step5: 'ٹرانزیکشن آئی ڈی کاپی کریں',
    step6: 'نیچے پیسٹ کریں',
    step7: 'ادائیگی کا اسکرین شاٹ اپ لوڈ کریں',
    transactionId: 'ٹرانزیکشن آئی ڈی درج کریں',
    transactionRequired: '* ضروری ہے',
    transactionPlaceholder: 'مثلاً: TXN123456789',
    screenshotLabel: '📸 ادائیگی کا اسکرین شاٹ اپ لوڈ کریں',
    screenshotUploaded: '✅ اسکرین شاٹ اپ لوڈ ہو گیا!',
    submitBtn: '✅ ادائیگی جمع کریں',
    submitting: '⏳ جمع ہو رہا ہے...',
    successTitle: 'ادائیگی جمع ہو گئی!',
    successMsg: 'ایڈمن 24 گھنٹے میں آپ کا پلان فعال کرے گا۔ تب تک مفت پلان استعمال کریں۔',
    goToDashboard: 'ڈیش بورڈ پر جائیں',
    errorTxn: 'ٹرانزیکشن آئی ڈی ضروری ہے!',
    errorScreenshot: 'اسکرین شاٹ ضروری ہے!',
    errorGeneral: 'خطا آ گئی!',
  },
  ar: {
    title: '💳 الدفع',
    selectedPlan: 'الخطة المختارة',
    paymentMethod: 'طريقة الدفع',
    howToPay: '📱 كيفية الدفع',
    step1: 'افتح التطبيق',
    step2: 'اذهب إلى إرسال الأموال',
    step3: 'أرسل إلى هذا الرقم:',
    step4: 'المبلغ:',
    step5: 'انسخ معرف المعاملة',
    step6: 'الصقه أدناه',
    step7: 'ارفع لقطة شاشة الدفع',
    transactionId: 'أدخل معرف المعاملة',
    transactionRequired: '* مطلوب',
    transactionPlaceholder: 'مثال: TXN123456789',
    screenshotLabel: '📸 ارفع لقطة شاشة الدفع',
    screenshotUploaded: '✅ تم رفع لقطة الشاشة!',
    submitBtn: '✅ إرسال الدفع',
    submitting: '⏳ جارٍ الإرسال...',
    successTitle: 'تم إرسال الدفع!',
    successMsg: 'سيقوم المشرف بتفعيل خطتك خلال 24 ساعة. استخدم الخطة المجانية حتى ذلك الحين.',
    goToDashboard: 'الذهاب إلى لوحة التحكم',
    errorTxn: 'معرف المعاملة مطلوب!',
    errorScreenshot: 'لقطة الشاشة مطلوبة!',
    errorGeneral: 'حدث خطأ!',
  },
  hi: {
    title: '💳 भुगतान',
    selectedPlan: 'चुना गया प्लान',
    paymentMethod: 'भुगतान विधि',
    howToPay: '📱 भुगतान कैसे करें',
    step1: 'ऐप खोलें',
    step2: 'Send Money पर जाएं',
    step3: 'इस नंबर पर भेजें:',
    step4: 'राशि:',
    step5: 'ट्रांजेक्शन ID कॉपी करें',
    step6: 'नीचे पेस्ट करें',
    step7: 'पेमेंट स्क्रीनशॉट अपलोड करें',
    transactionId: 'ट्रांजेक्शन ID दर्ज करें',
    transactionRequired: '* आवश्यक',
    transactionPlaceholder: 'जैसे: TXN123456789',
    screenshotLabel: '📸 पेमेंट स्क्रीनशॉट अपलोड करें',
    screenshotUploaded: '✅ स्क्रीनशॉट अपलोड हो गया!',
    submitBtn: '✅ भुगतान सबमिट करें',
    submitting: '⏳ सबमिट हो रहा है...',
    successTitle: 'भुगतान सबमिट हो गया!',
    successMsg: 'एडमिन 24 घंटे में आपका प्लान सक्रिय करेगा। तब तक Free प्लान उपयोग करें।',
    goToDashboard: 'डैशबोर्ड पर जाएं',
    errorTxn: 'ट्रांजेक्शन ID जरूरी है!',
    errorScreenshot: 'स्क्रीनशॉट जरूरी है!',
    errorGeneral: 'एरर आ गया!',
  },
  bn: { title: '💳 পেমেন্ট', selectedPlan: 'নির্বাচিত প্ল্যান', paymentMethod: 'পেমেন্ট পদ্ধতি', howToPay: '📱 কীভাবে পেমেন্ট করবেন', step1: 'অ্যাপ খুলুন', step2: 'Send Money-তে যান', step3: 'এই নম্বরে পাঠান:', step4: 'পরিমাণ:', step5: 'ট্রানজেকশন আইডি কপি করুন', step6: 'নিচে পেস্ট করুন', step7: 'পেমেন্ট স্ক্রিনশট আপলোড করুন', transactionId: 'ট্রানজেকশন আইডি লিখুন', transactionRequired: '* আবশ্যক', transactionPlaceholder: 'যেমন: TXN123456789', screenshotLabel: '📸 পেমেন্ট স্ক্রিনশট আপলোড করুন', screenshotUploaded: '✅ স্ক্রিনশট আপলোড হয়েছে!', submitBtn: '✅ পেমেন্ট জমা দিন', submitting: '⏳ জমা হচ্ছে...', successTitle: 'পেমেন্ট জমা হয়েছে!', successMsg: 'অ্যাডমিন ২৪ ঘণ্টার মধ্যে আপনার প্ল্যান সক্রিয় করবেন।', goToDashboard: 'ড্যাশবোর্ডে যান', errorTxn: 'ট্রানজেকশন আইডি আবশ্যক!', errorScreenshot: 'স্ক্রিনশট আবশ্যক!', errorGeneral: 'একটি ত্রুটি ঘটেছে!' },
  es: { title: '💳 Pago', selectedPlan: 'Plan Seleccionado', paymentMethod: 'Método de Pago', howToPay: '📱 Cómo Pagar', step1: 'Abre la app', step2: 'Ve a Enviar Dinero', step3: 'Envía a este número:', step4: 'Monto:', step5: 'Copia el ID de transacción', step6: 'Pégalo abajo', step7: 'Sube captura de pago', transactionId: 'Ingresa ID de Transacción', transactionRequired: '* Requerido', transactionPlaceholder: 'Ej: TXN123456789', screenshotLabel: '📸 Sube Captura de Pago', screenshotUploaded: '✅ ¡Captura subida!', submitBtn: '✅ Enviar Pago', submitting: '⏳ Enviando...', successTitle: '¡Pago Enviado!', successMsg: 'El admin activará tu plan en 24 horas.', goToDashboard: 'Ir al Panel', errorTxn: '¡ID de transacción requerido!', errorScreenshot: '¡Captura requerida!', errorGeneral: '¡Ocurrió un error!' },
  fr: { title: '💳 Paiement', selectedPlan: 'Plan Sélectionné', paymentMethod: 'Méthode de Paiement', howToPay: '📱 Comment Payer', step1: "Ouvrir l'app", step2: 'Aller à Envoyer de l\'argent', step3: 'Envoyer à ce numéro:', step4: 'Montant:', step5: 'Copier l\'ID de transaction', step6: 'Coller ci-dessous', step7: 'Télécharger la capture', transactionId: 'Entrez l\'ID de transaction', transactionRequired: '* Requis', transactionPlaceholder: 'Ex: TXN123456789', screenshotLabel: '📸 Télécharger la capture de paiement', screenshotUploaded: '✅ Capture téléchargée!', submitBtn: '✅ Soumettre le paiement', submitting: '⏳ Envoi...', successTitle: 'Paiement soumis!', successMsg: "L'admin activera votre plan sous 24h.", goToDashboard: 'Aller au tableau de bord', errorTxn: "L'ID de transaction est requis!", errorScreenshot: 'La capture est requise!', errorGeneral: 'Une erreur est survenue!' },
  de: { title: '💳 Zahlung', selectedPlan: 'Gewählter Plan', paymentMethod: 'Zahlungsmethode', howToPay: '📱 Wie bezahlen', step1: 'App öffnen', step2: 'Zu Geld senden gehen', step3: 'An diese Nummer senden:', step4: 'Betrag:', step5: 'Transaktions-ID kopieren', step6: 'Unten einfügen', step7: 'Zahlungsnachweis hochladen', transactionId: 'Transaktions-ID eingeben', transactionRequired: '* Erforderlich', transactionPlaceholder: 'z.B.: TXN123456789', screenshotLabel: '📸 Zahlungsnachweis hochladen', screenshotUploaded: '✅ Nachweis hochgeladen!', submitBtn: '✅ Zahlung einreichen', submitting: '⏳ Wird eingereicht...', successTitle: 'Zahlung eingereicht!', successMsg: 'Der Admin aktiviert Ihren Plan innerhalb von 24 Stunden.', goToDashboard: 'Zum Dashboard', errorTxn: 'Transaktions-ID erforderlich!', errorScreenshot: 'Screenshot erforderlich!', errorGeneral: 'Ein Fehler ist aufgetreten!' },
  zh: { title: '💳 付款', selectedPlan: '已选套餐', paymentMethod: '付款方式', howToPay: '📱 如何付款', step1: '打开应用', step2: '前往转账', step3: '转至此号码:', step4: '金额:', step5: '复制交易ID', step6: '粘贴到下方', step7: '上传付款截图', transactionId: '输入交易ID', transactionRequired: '* 必填', transactionPlaceholder: '例如: TXN123456789', screenshotLabel: '📸 上传付款截图', screenshotUploaded: '✅ 截图已上传！', submitBtn: '✅ 提交付款', submitting: '⏳ 提交中...', successTitle: '付款已提交！', successMsg: '管理员将在24小时内激活您的套餐。', goToDashboard: '前往控制台', errorTxn: '交易ID为必填项！', errorScreenshot: '截图为必填项！', errorGeneral: '发生了错误！' },
  ja: { title: '💳 お支払い', selectedPlan: '選択したプラン', paymentMethod: '支払い方法', howToPay: '📱 支払い方法', step1: 'アプリを開く', step2: '送金に移動', step3: 'このに送金:', step4: '金額:', step5: 'トランザクションIDをコピー', step6: '下に貼り付け', step7: '支払いスクリーンショットをアップロード', transactionId: 'トランザクションIDを入力', transactionRequired: '* 必須', transactionPlaceholder: '例: TXN123456789', screenshotLabel: '📸 支払いスクリーンショットをアップロード', screenshotUploaded: '✅ スクリーンショットがアップロードされました！', submitBtn: '✅ 支払いを送信', submitting: '⏳ 送信中...', successTitle: '支払いが送信されました！', successMsg: '管理者が24時間以内にプランを有効化します。', goToDashboard: 'ダッシュボードへ', errorTxn: 'トランザクションIDが必要です！', errorScreenshot: 'スクリーンショットが必要です！', errorGeneral: 'エラーが発生しました！' },
  ko: { title: '💳 결제', selectedPlan: '선택한 플랜', paymentMethod: '결제 방법', howToPay: '📱 결제 방법', step1: '앱 열기', step2: '송금으로 이동', step3: '이 번호로 송금:', step4: '금액:', step5: '거래 ID 복사', step6: '아래에 붙여넣기', step7: '결제 스크린샷 업로드', transactionId: '거래 ID 입력', transactionRequired: '* 필수', transactionPlaceholder: '예: TXN123456789', screenshotLabel: '📸 결제 스크린샷 업로드', screenshotUploaded: '✅ 스크린샷 업로드됨!', submitBtn: '✅ 결제 제출', submitting: '⏳ 제출 중...', successTitle: '결제 제출됨!', successMsg: '관리자가 24시간 이내에 플랜을 활성화합니다.', goToDashboard: '대시보드로 이동', errorTxn: '거래 ID가 필요합니다!', errorScreenshot: '스크린샷이 필요합니다!', errorGeneral: '오류가 발생했습니다!' },
  tr: { title: '💳 Ödeme', selectedPlan: 'Seçilen Plan', paymentMethod: 'Ödeme Yöntemi', howToPay: '📱 Nasıl Ödenir', step1: 'Uygulamayı aç', step2: "Para Gönder'e git", step3: 'Bu numaraya gönder:', step4: 'Tutar:', step5: 'İşlem kimliğini kopyala', step6: 'Aşağıya yapıştır', step7: 'Ödeme ekran görüntüsü yükle', transactionId: 'İşlem Kimliği Girin', transactionRequired: '* Zorunlu', transactionPlaceholder: 'Örn: TXN123456789', screenshotLabel: '📸 Ödeme Ekran Görüntüsü Yükle', screenshotUploaded: '✅ Ekran görüntüsü yüklendi!', submitBtn: '✅ Ödemeyi Gönder', submitting: '⏳ Gönderiliyor...', successTitle: 'Ödeme Gönderildi!', successMsg: 'Admin 24 saat içinde planınızı aktive eder.', goToDashboard: 'Panele Git', errorTxn: 'İşlem kimliği gerekli!', errorScreenshot: 'Ekran görüntüsü gerekli!', errorGeneral: 'Bir hata oluştu!' },
  ru: { title: '💳 Оплата', selectedPlan: 'Выбранный план', paymentMethod: 'Способ оплаты', howToPay: '📱 Как оплатить', step1: 'Открыть приложение', step2: 'Перейти к отправке денег', step3: 'Отправить на этот номер:', step4: 'Сумма:', step5: 'Скопировать ID транзакции', step6: 'Вставить ниже', step7: 'Загрузить скриншот оплаты', transactionId: 'Введите ID транзакции', transactionRequired: '* Обязательно', transactionPlaceholder: 'Пример: TXN123456789', screenshotLabel: '📸 Загрузить скриншот оплаты', screenshotUploaded: '✅ Скриншот загружен!', submitBtn: '✅ Отправить оплату', submitting: '⏳ Отправка...', successTitle: 'Оплата отправлена!', successMsg: 'Администратор активирует ваш план в течение 24 часов.', goToDashboard: 'На панель управления', errorTxn: 'ID транзакции обязателен!', errorScreenshot: 'Скриншот обязателен!', errorGeneral: 'Произошла ошибка!' },
  pt: { title: '💳 Pagamento', selectedPlan: 'Plano Selecionado', paymentMethod: 'Método de Pagamento', howToPay: '📱 Como Pagar', step1: 'Abrir o app', step2: 'Ir para Enviar Dinheiro', step3: 'Enviar para este número:', step4: 'Valor:', step5: 'Copiar ID da transação', step6: 'Colar abaixo', step7: 'Enviar captura de tela', transactionId: 'Inserir ID da Transação', transactionRequired: '* Obrigatório', transactionPlaceholder: 'Ex: TXN123456789', screenshotLabel: '📸 Enviar Captura de Tela do Pagamento', screenshotUploaded: '✅ Captura enviada!', submitBtn: '✅ Enviar Pagamento', submitting: '⏳ Enviando...', successTitle: 'Pagamento Enviado!', successMsg: 'O admin ativará seu plano em 24 horas.', goToDashboard: 'Ir ao Painel', errorTxn: 'ID de transação obrigatório!', errorScreenshot: 'Captura obrigatória!', errorGeneral: 'Ocorreu um erro!' },
  fa: { title: '💳 پرداخت', selectedPlan: 'طرح انتخاب‌شده', paymentMethod: 'روش پرداخت', howToPay: '📱 نحوه پرداخت', step1: 'اپ را باز کنید', step2: 'به ارسال پول بروید', step3: 'به این شماره ارسال کنید:', step4: 'مبلغ:', step5: 'شناسه تراکنش را کپی کنید', step6: 'در زیر جای‌گذاری کنید', step7: 'اسکرین‌شات پرداخت را آپلود کنید', transactionId: 'شناسه تراکنش را وارد کنید', transactionRequired: '* الزامی', transactionPlaceholder: 'مثال: TXN123456789', screenshotLabel: '📸 اسکرین‌شات پرداخت را آپلود کنید', screenshotUploaded: '✅ اسکرین‌شات آپلود شد!', submitBtn: '✅ ارسال پرداخت', submitting: '⏳ در حال ارسال...', successTitle: 'پرداخت ارسال شد!', successMsg: 'مدیر ظرف ۲۴ ساعت طرح شما را فعال خواهد کرد.', goToDashboard: 'رفتن به داشبورد', errorTxn: 'شناسه تراکنش الزامی است!', errorScreenshot: 'اسکرین‌شات الزامی است!', errorGeneral: 'خطایی رخ داد!' },
};

function Payment({ user, plan, onBack, onSuccess }) {
  const getSavedLang = () => {
    const saved = localStorage.getItem('cineshorts_lang');
    if (saved) {
      const found = LANGUAGES.find(l => l.code === saved);
      if (found) return found;
    }
    return LANGUAGES[0];
  };

  const [selectedLang] = useState(getSavedLang);
  const t = TRANSLATIONS[selectedLang.code] || TRANSLATIONS['en'];
  const isRTL = ['ar', 'ur', 'fa'].includes(selectedLang.code);

  const [paymentMethod, setPaymentMethod] = useState('jazzcash');
  const [transactionId, setTransactionId] = useState('');
  const [screenshot, setScreenshot] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);

  const paymentNumbers = { jazzcash: '03269174270', easypaisa: '03269174270' };

  const handleSubmit = async () => {
    if (!transactionId.trim()) { setError(t.errorTxn); return; }
    if (!screenshot) { setError(t.errorScreenshot); return; }
    setLoading(true);
    setError('');
    try {
      await axios.post(`${API}/auth/upgrade-plan`, {
        phone: user.phone, plan: plan.id,
        payment_method: paymentMethod,
        transaction_id: transactionId,
        amount: plan.id === 'pro_basic' ? 2000 : 4500
      });
      setSuccess(true);
    } catch (err) {
      setError(err.response?.data?.detail || t.errorGeneral);
    }
    setLoading(false);
  };

  const cardStyle = {
    background: '#1a1a1a', border: '1px solid #2a2a2a',
    borderRadius: '16px', padding: '20px', marginBottom: '16px'
  };

  const labelStyle = { color: '#d1d5db', fontSize: '14px', fontWeight: '700', marginBottom: '12px', display: 'block' };
  const inputStyle = {
    width: '100%', padding: '14px 16px',
    background: 'rgba(255,255,255,0.07)',
    border: '1px solid rgba(245,158,11,0.2)',
    borderRadius: '12px', color: '#fff', fontSize: '15px',
    outline: 'none', boxSizing: 'border-box', direction: 'ltr'
  };

  if (success) {
    return (
      <div style={{ minHeight: '100vh', background: '#0f0f0f', display: 'flex', alignItems: 'center', justifyContent: 'center', direction: isRTL ? 'rtl' : 'ltr' }}>
        <div style={{ background: '#1a1a1a', border: '1px solid rgba(245,158,11,0.3)', borderRadius: '24px', padding: '40px', maxWidth: '400px', width: '90%', textAlign: 'center' }}>
          <div style={{ fontSize: '64px', marginBottom: '16px' }}>✅</div>
          <h2 style={{ fontSize: '22px', fontWeight: '800', color: '#f59e0b', marginBottom: '12px' }}>{t.successTitle}</h2>
          <p style={{ color: '#9ca3af', marginBottom: '24px', lineHeight: '1.6' }}>{t.successMsg}</p>
          <button onClick={onSuccess} style={{
            width: '100%', padding: '14px',
            background: 'linear-gradient(90deg, #f59e0b, #d97706)',
            border: 'none', borderRadius: '12px',
            color: '#000', fontWeight: '800', fontSize: '16px', cursor: 'pointer'
          }}>{t.goToDashboard}</button>
        </div>
      </div>
    );
  }

  return (
    <div style={{ minHeight: '100vh', background: '#0f0f0f', color: '#fff', direction: isRTL ? 'rtl' : 'ltr' }}>

      {/* Header */}
      <div style={{ background: '#111', borderBottom: '1px solid #2a2a2a', padding: '16px 24px', display: 'flex', alignItems: 'center', gap: '16px' }}>
        <button onClick={onBack} style={{ background: 'none', border: 'none', color: '#f59e0b', fontSize: '20px', cursor: 'pointer' }}>←</button>
        <h1 style={{ fontSize: '20px', fontWeight: '800', background: 'linear-gradient(90deg, #f59e0b, #fbbf24)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>
          {t.title}
        </h1>
      </div>

      <div style={{ maxWidth: '500px', margin: '0 auto', padding: '24px 16px' }}>

        {/* Selected Plan */}
        <div style={{ ...cardStyle, border: '1px solid rgba(245,158,11,0.3)' }}>
          <p style={{ color: '#9ca3af', fontSize: '13px' }}>{t.selectedPlan}</p>
          <p style={{ fontSize: '20px', fontWeight: '800', color: '#f59e0b', marginTop: '4px' }}>{plan?.name}</p>
          <p style={{ fontSize: '22px', fontWeight: '800', color: '#fff', marginTop: '4px' }}>{plan?.price}</p>
        </div>

        {/* Payment Method */}
        <div style={cardStyle}>
          <span style={labelStyle}>{t.paymentMethod}</span>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px' }}>
            {['jazzcash', 'easypaisa'].map(method => (
              <button key={method} onClick={() => setPaymentMethod(method)} style={{
                padding: '12px', borderRadius: '12px', fontWeight: '700', fontSize: '14px', cursor: 'pointer',
                border: paymentMethod === method ? '2px solid #f59e0b' : '2px solid #2a2a2a',
                background: paymentMethod === method ? 'rgba(245,158,11,0.1)' : 'transparent',
                color: paymentMethod === method ? '#f59e0b' : '#9ca3af',
              }}>
                {method === 'jazzcash' ? 'JazzCash' : 'EasyPaisa'}
              </button>
            ))}
          </div>
        </div>

        {/* How to Pay */}
        <div style={{ ...cardStyle, background: 'rgba(245,158,11,0.05)', border: '1px solid rgba(245,158,11,0.2)' }}>
          <h4 style={{ color: '#f59e0b', fontWeight: '700', marginBottom: '12px' }}>{t.howToPay}</h4>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', fontSize: '14px', color: '#d1d5db' }}>
            <p>1️⃣ {paymentMethod === 'jazzcash' ? 'JazzCash' : 'EasyPaisa'} {t.step1}</p>
            <p>2️⃣ {t.step2}</p>
            <p>3️⃣ {t.step3}</p>
            <p style={{ fontSize: '22px', fontWeight: '800', color: '#f59e0b', textAlign: 'center', padding: '8px 0' }}>
              {paymentNumbers[paymentMethod]}
            </p>
            <p>4️⃣ {t.step4} <strong style={{ color: '#f59e0b' }}>{plan?.price}</strong></p>
            <p>5️⃣ {t.step5}</p>
            <p>6️⃣ {t.step6}</p>
            <p>7️⃣ {t.step7}</p>
          </div>
        </div>

        {/* Transaction ID */}
        <div style={cardStyle}>
          <label style={labelStyle}>
            {t.transactionId} <span style={{ color: '#ef4444' }}>{t.transactionRequired}</span>
          </label>
          <input
            type="text" value={transactionId}
            onChange={(e) => setTransactionId(e.target.value)}
            placeholder={t.transactionPlaceholder}
            style={inputStyle}
          />
        </div>

        {/* Screenshot */}
        <div style={cardStyle}>
          <label style={labelStyle}>
            {t.screenshotLabel} <span style={{ color: '#ef4444' }}>{t.transactionRequired}</span>
          </label>
          <input
            type="file" accept="image/*"
            onChange={(e) => setScreenshot(e.target.files[0])}
            style={{ ...inputStyle, border: '2px dashed rgba(245,158,11,0.3)', cursor: 'pointer', padding: '12px' }}
          />
          {screenshot && (
            <div style={{ marginTop: '12px' }}>
              <img src={URL.createObjectURL(screenshot)} alt="Payment Screenshot"
                style={{ width: '100%', borderRadius: '12px', maxHeight: '200px', objectFit: 'cover' }} />
              <p style={{ color: '#f59e0b', fontSize: '13px', marginTop: '8px', textAlign: 'center' }}>{t.screenshotUploaded}</p>
            </div>
          )}
        </div>

        {/* Error */}
        {error && (
          <div style={{ background: 'rgba(239,68,68,0.1)', border: '1px solid rgba(239,68,68,0.3)', color: '#f87171', padding: '12px 16px', borderRadius: '12px', marginBottom: '16px' }}>
            {error}
          </div>
        )}

        {/* Submit Button */}
        <button
          onClick={handleSubmit}
          disabled={loading || !transactionId.trim() || !screenshot}
          style={{
            width: '100%', padding: '16px',
            background: transactionId.trim() && screenshot
              ? 'linear-gradient(90deg, #f59e0b, #d97706)' : '#2a2a2a',
            border: 'none', borderRadius: '12px',
            color: transactionId.trim() && screenshot ? '#000' : '#6b7280',
            fontWeight: '800', fontSize: '16px',
            cursor: transactionId.trim() && screenshot ? 'pointer' : 'not-allowed',
            marginBottom: '32px'
          }}
        >
          {loading ? t.submitting : t.submitBtn}
        </button>
      </div>
    </div>
  );
}

export default Payment;
